exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-overlay__info-overlay__eRaQu{position:absolute;top:0;left:0;right:0;bottom:0;z-index:10;transition:opacity .2s;opacity:0}.info-overlay__info-overlay__eRaQu.info-overlay__show__3bGQN{opacity:1}.info-overlay__close__3HEpG{position:absolute;z-index:2;top:17px;right:17px;overflow:hidden;color:hsla(0,0%,100%,.7);font-size:20px;cursor:pointer}.info-overlay__close-fullscreen__1bzZl{font-size:41px}.info-overlay__content__26mq-{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;color:#fff;background-color:rgba(0,0,0,.85)}.info-overlay__content__26mq-.info-overlay__half__3p4PT{left:50%}.info-overlay__content__26mq-.info-overlay__at-full-screen__2pBpt{left:calc(100% - 630px)}.info-overlay__background-overlay__1Intr{position:absolute;top:0;left:0;right:0;bottom:0;background-color:transparent}@media (max-width:639px){.info-overlay__info-overlay__eRaQu{width:100%;max-width:480px;left:auto}.info-overlay__info-overlay__eRaQu.info-overlay__full-width__2AQ7z{max-width:none}.info-overlay__content__26mq-.info-overlay__at-full-screen__2pBpt,.info-overlay__content__26mq-.info-overlay__half__3p4PT{left:0}}", ""]);

// exports
exports.locals = {
	"info-overlay": "info-overlay__info-overlay__eRaQu",
	"infoOverlay": "info-overlay__info-overlay__eRaQu",
	"show": "info-overlay__show__3bGQN",
	"close": "info-overlay__close__3HEpG",
	"close-fullscreen": "info-overlay__close-fullscreen__1bzZl",
	"closeFullscreen": "info-overlay__close-fullscreen__1bzZl",
	"content": "info-overlay__content__26mq-",
	"half": "info-overlay__half__3p4PT",
	"at-full-screen": "info-overlay__at-full-screen__2pBpt",
	"atFullScreen": "info-overlay__at-full-screen__2pBpt",
	"background-overlay": "info-overlay__background-overlay__1Intr",
	"backgroundOverlay": "info-overlay__background-overlay__1Intr",
	"full-width": "info-overlay__full-width__2AQ7z",
	"fullWidth": "info-overlay__full-width__2AQ7z"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/player/info-overlay/info-overlay.styl
// module id = 1309
// module chunks = 0 1 2 3